/**
 * SettingsCtrl controller
 * Add/edit package
 */

import { GET_TIMEZONES } from 'app/core/constants'

/**
 * SettingsCtrl controller
 *
 * @class SettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SettingsCtrl
 */
/* @ngInject */
export default function SettingsCtrl ($scope, $uibModal, $location, alertSvc, NetworkChannelLink, NetworkThemeLink, Channel, pckg, Network, subscriptions, inapp, storageSvc, authSvc) {
  const vm = this

  /**
   *
   * @type {{ subscription: Subscription, channel: Channel }}
   */
  vm.startChannel = {}

  /**
   * Collection of loaded channels for subscriptions
   * @type {{ [subscriptionId:Number]:[Channel]}}
   */
  vm.channelsBySubscription = {}

  /**
   * Loaded subscriptions for current organization with type 'subscription'
   */
  vm.subscriptions = subscriptions

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Loading assigned start channel and subscriptions for current organization
   */
  if (vm.pckg.startChannelSettingsEnabled) {
    vm.pckg._loadStartChannels()
  } else {
    vm.pckg.$startChannelSettingsDto = []
  }

  /**
   * loading channels for subscription, which can be a start channel
   * @param subscription
   * @param editChannel
   */
  vm.getChannels = function (subscription, editChannel = true) {
    if (!editChannel) {
      vm.startChannel.channel = null
    }

    if (!vm.channelsBySubscription[subscription.id]) {
      let s = subscription

      if (editChannel) {
        s = vm.subscriptions.find(({ id }) => id === subscription.id)
        if (!s) {
          return
        }
      }
      s._loadChannels()
        .then(channels => channels.map(ch => ({ ...ch, inSubscription: true })))
        .to(vm.channelsBySubscription[subscription.id] = [])
    }
  }

  /**
   * Assign combination of subscription and channel to start channels array
   */
  vm.addStartChannel = function () {
    if (vm.startChannel.subscription && vm.startChannel.channel) {
      const stChannelId = vm.pckg.$startChannelSettingsDto
        .findIndex(item => item.subscription.id === vm.startChannel.subscription.id)
      if (stChannelId > -1) {
        vm.pckg.$startChannelSettingsDto[stChannelId].channel = vm.startChannel.channel
      } else {
        vm.pckg.$startChannelSettingsDto.push({ ...vm.startChannel })
      }
      vm.startChannel = {}
    }
  }

  /**
   * Remove start channel from list
   * @param subscriptionId
   */
  vm.removeStartChannel = function (subscriptionId) {
    vm.pckg.$startChannelSettingsDto = vm.pckg.$startChannelSettingsDto
      .filter((item) => item.subscription.id !== subscriptionId)
  }

  vm.setValidators = function (field, ch) {
    field.$setValidity('notEnabled', !!ch.enabled)
    field.$setValidity('notInSubscription', !!ch.inSubscription)
  }

  /**
   * Check FF
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @type {mwApp/auth.service}
   */
  vm.authSvc = authSvc

  vm.PROVIDER = window.ENV.APP_PROVIDER

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Default Package for in-app registration
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @type {number}
   */
  vm.inappNetworkId = !inapp?.multiorgEnabled && inapp?.inAppRegistrationSettings?.enabled && inapp.inAppRegistrationSettings.network?.id

  /**
   * Default Package for Guest Mode
   *
   * @memberof mwApp/packages.controller:SubscriptionSettingsCtrl
   * @type {number}
   */
  vm.guestNetworkId = !inapp?.multiorgEnabled && inapp?.guestModeSettings?.enabled && inapp.guestModeSettings.network?.id

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @type {Boolean}
   */
  vm.isNew = pckg._isNew()

  /**
   * Timezones
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @type {String[]}
   */
  GET_TIMEZONES().to(vm.timezones = [])

  /**
   * Screen saver
   *
   * @memberof mwApp/settings.controller:SettingsCtrl
   * @type {Number}
   */
  vm.defaultNetworkScreenSaver = 0

  /**
   * System timezone
   *
   * @memberof mwApp/settings.controller:SettingsCtrl
   * @type {String}
   */
  vm.systemTimezone = ''

  /**
   * Set timezone to default value
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @function
   */
  vm.setTZ = () => {
    if (vm.tzDef) {
      vm.pckg.timezone = vm.systemTimezone
    }
  }

  /**
   * Change timezone field
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @function
   */
  vm.changeTZ = () => {
    vm.tzDef = vm.pckg.timezone === vm.systemTimezone
  }

  /**
   * Set random pincode
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @function
   */
  vm.setPincode = () => {
    if (vm.pincode) {
      vm.pckg.pincode = ''
    }
  }

  /**
   * Change pincode field
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   * @function
   */
  vm.changePincode = () => {
    vm.pincode = !vm.pckg.pincode || vm.pckg.pincode === ''
  }

  pckg.listingType = pckg.listingType || 'Sequence'
  var originalListingType = pckg.listingType // save package listingType in order to check it later

  // load extra params
  Network.loadExtra({ id: pckg.id, url: '?stbSettings=true' })
    .to(vm)
    .then(() => {
      vm.changeTZ()
    })

  /**
   * Update package/network
   *
   * @memberof mwApp/packages.controller:SettingsCtrl
   */
  vm.save = function () {
    function doSave () {
      vm.setDisable()
      vm.pckg.startChannelSettingsDto = vm.pckg.$startChannelSettingsDto
        .map((st) => ({
          subscriptionId: st.subscription.id,
          channelId: st.channel.id
        }))

      // save package
      pckg._save(null, null, null, null).finally(() => {
        alertSvc.alert('Organization settings updated', 'success')
        vm.unsetDisable()
        vm.location.reload()
      })
    }

    // check if listingType was changed
    if (!vm.isNew && originalListingType !== pckg.listingType) {
      alertSvc.confirm('You\'ve changed Channel Listing, all assigned channels will be lost, are you sure?')
        .then(doSave)
    } else {
      doSave()
    }
  }

  vm.hasFlag = (flag) => {
    return authSvc.hasEnabledFlag(flag)
  }

  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicListUrl)
    }
  }
}
